import i18n from '@/utils/i18n';

const fields =
    [
        {
            name: "allowed_email_regexp",
            type: "select",
            multiple: true,
            taggable: true,
            placeholder: i18n.t('form.type_your_regexp'),
            options: [],
            searchable: true,
            label: i18n.t('teams.allowed_emails_regexp'),
        },
        {
            name: "subscription_id",
            type: "select",
            multiple: false,
            searchable: true,
            group: true,
            options_url: "plans?limit=100",
            filter_field: 'title',
            label: i18n.t('form.subscriptions_id'),
        },
        {
            name: "active",
            type: "select",
            main: false,
            multiple: false,
            preselectFirst: true,
            searchable: false,
            label: i18n.t('form.status'),
            options: [
              {
                value: true,
                name: i18n.t('user_status.true')
              },
              {
                value: false,
                name: i18n.t('user_status.false')
              }
          ]
        },
      {
        name: "type",
        type: "select",
        preselectFirst: true,
        multiple: false,
        label: i18n.t('groups.group_type'),
        options: [
          {
            name: i18n.t('form.any'),
            value: ''
          },
          {
            name: i18n.t('teams.company'),
            value: 'company'
          },
          {
            name: i18n.t('teams.personal'),
            value: 'personal'
          },
          {
            name: i18n.t('teams.company_subdivision'),
            value: 'company_subdivision'
          },
          {
            name: i18n.t('teams.organization'),
            value: 'organization'
          },
          {
            name: i18n.t('teams.educational_institution'),
            value: 'educational_institution'
          },
          {
            name: i18n.t('teams.multi_user'),
            value: 'multi_user'
          }
        ]
      },
      {
        name: "subscription_end_date",
        label: i18n.t('form.subscription_end_date'),
        type: "date",
        main: false,
        isRange: false,
        mode: 'date',
      }
    ];

export default fields
